<template>
  <div class="vendor-menu-message__container">
    <div v-if="showAlert" class="vendor-menu-message__alert">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 191.812 191.812">
        <g fill="#e34b4b">
          <path
            d="M95.906,121.003c6.903,0,12.5-5.597,12.5-12.5V51.511c0-6.904-5.597-12.5-12.5-12.5   s-12.5,5.596-12.5,12.5v56.993C83.406,115.407,89.003,121.003,95.906,121.003z"
          />
          <path
            d="M95.909,127.807c-3.29,0-6.521,1.33-8.841,3.66c-2.329,2.32-3.659,5.54-3.659,8.83   s1.33,6.52,3.659,8.84c2.32,2.33,5.551,3.66,8.841,3.66s6.51-1.33,8.84-3.66c2.319-2.32,3.66-5.55,3.66-8.84s-1.341-6.51-3.66-8.83   C102.419,129.137,99.199,127.807,95.909,127.807z"
          />
          <path
            d="M95.906,0C43.024,0,0,43.023,0,95.906s43.023,95.906,95.906,95.906s95.905-43.023,95.905-95.906   S148.789,0,95.906,0z M95.906,176.812C51.294,176.812,15,140.518,15,95.906S51.294,15,95.906,15   c44.611,0,80.905,36.294,80.905,80.906S140.518,176.812,95.906,176.812z"
          />
        </g>
      </svg>
      <h2 class="m-t-20">No Camera Found</h2>
      <p class="m-t-30">Sorry! This experience requires a device camera to scan items</p>
    </div>

    <div v-if="showInfo" class="vendor-menu-message__info">
      <p class="m-b-60">Click on the Scan Items button below to begin scanning</p>
      <svg xmlns="http://www.w3.org/2000/svg" width="224" height="192" viewBox="0 0 224 192">
        <g fill="#000" fill-rule="nonzero">
          <path
            d="M177.333 192v-9.366h37.334v-37.463H224V192h-46.667zm4.625-32.78V32.78h9.396v126.44h-9.396zM214.667 9.366h-37.334V0H224v46.83h-9.333V9.365zM160.995 32.78h14.028v126.44h-14.028V32.78zm-30.35 0h25.69v126.44h-25.69V32.78zm-25.615 0h13.956v126.44H105.03V32.78zm-14.051 0h4.7v126.44h-4.7V32.78zm-18.636 0H86.3v126.44H72.343V32.78zm-39.676 0H62.98v126.44H32.667V32.78zM9.333 46.83H0V0h46.667v9.366H9.333v37.463zm0 135.804h37.334V192H0v-46.83h9.333v37.464z"
            transform="translate(-76 -317) translate(76 317)"
          />
        </g>
      </svg>
      <app-button class="m-t-50" text="Scan items" :aria-label="'Scan items'" :handler="openScanModal" />
    </div>
  </div>
</template>

<script>
import ScanAndGoMixin from "@/mixins/scan-and-go.mixin";

export default {
  name: "MenuMessage",
  mixins: [ScanAndGoMixin],
  props: {
    showAlert: {
      type: Boolean,
      default: false
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.vendor-menu-message__container {
  width: 300px;
  margin: auto;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  p {
    text-align: center;
    font-size: 20px;
  }

  .vendor-menu-message__info {
    p {
      color: #020202;
    }
  }

  .vendor-menu-message__alert {
    p {
      color: #787878;
    }
    svg {
      height: 100px;
    }
  }
}
</style>
